module.exports = __webpack_public_path__ + "static/img/activityNot.63223ec.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/activityNot.png
// module id = KjRK
// module chunks = 4